export interface SavingsRow {
  label: string
  hydro: { value: string; good: boolean }
  salt: { value: string; good: boolean }
}

export const savingsRows: SavingsRow[] = [
  {
    label: '100% chemical-free system',
    hydro: { value: 'Yes', good: true },
    salt: { value: 'No', good: false },
  },
  {
    label: 'Needs chlorine generator & chemicals',
    hydro: { value: 'Never', good: true },
    salt: { value: 'Required', good: false },
  },
  {
    label: 'Staining & etching',
    hydro: { value: 'None', good: true },
    salt: { value: 'Common', good: false },
  },
  {
    label: 'Eco friendly & safe',
    hydro: { value: 'Yes', good: true },
    salt: { value: 'No', good: false },
  },
  {
    label: 'Needs stabilizer',
    hydro: { value: 'No', good: true },
    salt: { value: 'Yes', good: false },
  },
  {
    label: 'EPA-level clean',
    hydro: { value: 'Yes', good: true },
    salt: { value: 'No', good: false },
  },
  {
    label: 'Warranty',
    hydro: { value: 'Lifetime', good: true },
    salt: { value: '1 year', good: false },
  },
]

export const savingsTotals = {
  hydro: { label: 'Yearly national average cost', value: '$500\u2013$650' },
  salt: { label: 'Yearly national average cost', value: '$3,000\u2013$5,000' },
  delta: '$2,350\u2013$4,500',
}
